import {
	BreakpointOverrideIndicator,
	BreakpointOverrideCellInner,
} from '@dealstack/frontend/app/pages/Valuations/views/BreakpointSummary/BreakpointSummaryTable/styled';
import { useTranslationValuations } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Text } from '@mantine/core';

interface Props {
	value: string;
}

export const BreakpointCell = ({ value }: Props) => {
	const tValuations = useTranslationValuations();
	return (
		<BreakpointOverrideCellInner>
			<BreakpointOverrideIndicator>
				<Text size="B6Medium">{tValuations('breakpoint_summary.overridden_tag')}</Text>
			</BreakpointOverrideIndicator>
			<Text size="B6Medium">{value}</Text>
		</BreakpointOverrideCellInner>
	);
};
